
const digest = '343424c1dd9ce6a3902cd102ab6ceef227e93f5a3b38e021afc69bd44de01ebb';
const classes = {"wrapper":"_wrapper_1ln9s_1"};
const css = `._wrapper_1ln9s_1 {
  background-color: #fff;
  padding: 20px;
  border: 1px solid #eaedf3;
  font-family: Rubik, sans-serif;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  